import queryString from 'query-string'

const queryParameters = () => {
  const getParam = (param) => {
    const params = queryString.parse(window.location.search)
    return params[param]
  }

  const getParams = () => {
    return queryString.parse(window.location.search, {
      arrayFormat: 'bracket-separator',
      arrayFormatSeparator: ',',
    })
  }

  const setParams = (object) => {
    const string = parseParamsObject(object)
    const { protocol, host, pathname } = window.location
    const newURL = `${protocol}//${host}${pathname}?${string}`
    window.history.pushState({ path: newURL }, '', newURL)
  }

  const isActive = ({ param, defaultValue = 'all', value }) => {
    const activeParamValue = queryParameters().getParam(param) || defaultValue
    return activeParamValue === value
  }

  const parseParamsObject = (object) => {
    return queryString.stringify(object, {
      arrayFormat: 'bracket-separator',
      arrayFormatSeparator: ',',
    })
  }

  return { getParam, setParams, getParams, parseParamsObject, isActive }
}

export { queryParameters }
